import { Link } from "react-router-dom"

const Missing = () => {
    return (
        <section className="fade-in" style={{ textAlign: "center", maxWidth: "600px" }}>
            <div style={{ fontSize: "4rem", marginBottom: "1rem" }}>🤔</div>
            <h1 style={{
                fontSize: "3rem",
                marginBottom: "1rem",
                background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
            }}>
                404
            </h1>
            <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "var(--text-primary)" }}>
                Page Not Found
            </h2>
            <p style={{ color: "var(--text-secondary)", marginBottom: "2rem", fontSize: "1.125rem" }}>
                The page you are looking for does not exist or has been moved.
            </p>
            <div className="flexGrow">
                <Link to="/">
                    <button className="btn-primary">
                        Visit Homepage
                    </button>
                </Link>
            </div>
        </section>
    )
}

export default Missing
